<template>
  <div class="promotes">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for>Yurt Ara</label>
          <input
            class="form-control custom-input"
            type="text"
            placeholder="Yurt Adı"
            v-model="search"
          >
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for>Reklam Tipi</label>
          <select class="form-control custom-input" v-model="promote_type" @change="filterPromoteType">
            <option value="">Tümü</option>
            <option v-for="promote in promotes" :key="promote.id" :value="promote.id">{{ promote.name }}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="widget">
          <div class="table-area">
            <div class="widget-title">
              <h3>
                <i :class="icon"></i>
                {{ tableName }}
              </h3>
              <span>{{ tableDesc }}</span>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Yurt</th>
                    <th>Reklam Tipi</th>
                    <th>Bitiş Tarihi</th>
                    <th>İl</th>
                    <th>İlçe</th>
                    <th>Üniversite</th>
                    <th>İşlemler</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in filteredList" :key="item.id">
                    <td>{{ item.dorm.name }}</td>
                    <td>{{ item.promote }}</td>
                    <td>{{ item.end_date | dateFormat }}</td>
                    <td v-if="item.city">{{ item.city.name }}</td>
                    <td v-else=""><small>İl Belirtilmemiş</small></td>
                    <td v-if="item.district">{{ item.district.name }}</td>
                    <td v-else=""><small>İlçe Belirtilmemiş</small></td>
                    <td v-if="item.university">{{ item.university.name }}</td>
                    <td v-else=""><small>Üniversite Belirtilmemiş</small></td>
                    <td>
                      <router-link
                        :to="{ name: 'promotes.update', params: {id: item.id} }"
                        class="btn btn-primary btn-xs"
                      >
                    
                        <span>Düzenle</span>
                      </router-link> /
                      <button class="btn btn-danger btn-xs" @click="destroy(item)">
                         Sil
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  component: { moment },
  data() {
    return {
      tableName: "Reklamlar Tablosu",
      icon: "fa fa-cart-plus",
      tableDesc: "",
      api: "promotes/",
      items: [],
      search: "",
      promote_type: '',
      promotes: [],
    };
  },
  mounted() {
    this.fetchPosts();
  },
  methods: {
    fetchPosts() {
      this.$Progress.start();
      this.axios.get(this.api).then(response => {
        // console.log(response);
        this.items = response.data.data;
        this.promotes = response.data.promotes;
        this.$Progress.finish();
      });
    },
    destroy(item) {
      this.$swal({
        title: "Silmek istediğinizden emin misiniz?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "İptal"
      }).then(result => {
        if (result.value) {
          this.axios.delete(this.api + item.id).then(response => {
            if (response.status == 200) {
              this.$swal("Başarılı!", "Veri silme işlemi başarılı", "success");
              this.items.splice(this.items.indexOf(item), 1);
            }
          });
        }
      });
    },
    filterPromoteType() {
      this.$Progress.start();
      this.axios.get(this.api, { params: { 'promote_type': this.promote_type }})
        .then(response => {
          this.items = response.data.data;
          this.$Progress.finish();
        })
    }
  },
  filters: {
    dateFormat: function(date) {
      if (!date) return "";
      moment.locale("tr");
      date = moment(date).format("L");
      return date;
    }
  },
  computed: {
    filteredList() {
      return this.items.filter(item => {
        return item.dorm.name.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  }
};
</script>

<style scoped>
</style>
